import React from 'react'
import {MdKeyboardArrowLeft, MdKeyboardArrowRight} from 'react-icons/md'
import classnames from 'classnames'

import styles from './styles.module.css'

export default function Pagination({page, setPage, hasNextPage, hasPreviousPage, totalPages}) {
  let startPage, endPage

  startPage = Math.max(1, page - 2)
  endPage = Math.min(totalPages, page + 2)

  if (endPage - startPage < 4) {
    if (page - startPage < 2) {
      endPage = Math.min(totalPages, endPage + 2 - (page - startPage))
    } else if (endPage - page < 2) {
      startPage = Math.max(1, startPage - 2 + (endPage - page))
    }
  }

  return (
    <div className={styles.container}>
      <MdKeyboardArrowLeft
        size="1.5em"
        className={classnames(
          styles.smallSpaceRight,
          hasPreviousPage ? styles.pointer : styles.disabled
        )}
        onClick={() => hasPreviousPage && setPage(page - 1)}
      />
      {Array(endPage - startPage + 1)
        .fill(null)
        .map((_, idx) => (
          <span
            key={idx}
            className={classnames(
              styles.spaceRight,
              page === startPage + idx ? styles.activeBox : styles.box
            )}
            onClick={() => setPage(startPage + idx)}>
            {startPage + idx}
          </span>
        ))}
      <MdKeyboardArrowRight
        size="1.5em"
        className={hasNextPage ? styles.pointer : styles.disabled}
        onClick={() => hasNextPage && setPage(page + 1)}
      />
    </div>
  )
}
